import React from 'react';
import { ticker } from '../data/site';
export function Ticker() {
  const items = [...ticker, ...ticker];
  return <div className="overflow-hidden border-y border-edge bg-carbon py-4" data-id="element-751" data-mp="2h219e3r5kwt1">
      <div className="ticker-track flex w-max items-center gap-8" data-id="element-752" data-mp="2v3dne9mr6oca">
        {items.map((word, i) => <span key={`${word}-${i}`} className="flex items-center gap-8" data-id="element-753" data-mp="2q391g432t1eo" data-mpi={i}>
            <span className="whitespace-nowrap font-display text-sm font-semibold uppercase tracking-[0.18em] text-chalk/70" data-id="element-754" data-mp="22e6eqhtl4idb">
              {word}
            </span>
            <span className="h-1 w-1 rotate-45 bg-ember" aria-hidden="true" data-id="element-755" data-mp="1yefr2mzcuid0" />
          </span>)}
      </div>
    </div>;
}